/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import {
  FETCH_PRODUCTS,
  FETCH_PRODUCT,
  FETCH_SAVEPRODUCT,
  SET_ACTIVE,
  SELECT_PRODUCT,
  FETCH_CATEGORIES,
} from '../types'

export function products(state = {}, action) {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return action.data
    case SET_ACTIVE:
      const arr = [...state.data]
      const index = arr.map((products) => products.id).indexOf(action.id)
      if (index >= 0) {
        arr[index].active = action.value
      }
      state.data = arr
      return { ...state }
    default:
      return state
  }
}

export function product(state = {}, action) {
  switch (action.type) {
    case FETCH_PRODUCT:
      return action.data
    default:
      return state
  }
}

export function categories(state = {}, action) {
  switch (action.type) {
    case FETCH_CATEGORIES:
      return action.data
    default:
      return state
  }
}
export function saveProduct(state = [], action) {
  switch (action.type) {
    case FETCH_SAVEPRODUCT:
      return action.data
    default:
      return state
  }
}

export const selectProduct = (state = '', action) => {
  switch (action.type) {
    case SELECT_PRODUCT:
      return action.data
    default:
      return state
  }
}
